/* eslint-disable no-template-curly-in-string */
/* eslint-disable no-loop-func */
import React from 'react';
import { createContext, useContext } from 'react';
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import _ from 'lodash';
import h2p from 'html2plaintext';
import parse from "html-react-parser";
import moment from 'moment';

import { axios } from '../../../../../v5/utils/axios';
import { success, successAPI, errorAPI, createEditorState, dateTimeMeridianFormat, timeMeridianFormat, dateFormat, concatDateTimeNoConvrsion, getCurrency, formatNumber , isNumeric} from '../../../../../v5/utils/utils';
import Yup from '../../../../../v5/utils/yup';
import { AccountDocSettingType, AccountDocSettingVariables, ProformaInvoiceStatus, ProformaPaymentType, AccountEmailTemplateType, ServiceType } from '../../../../../v5/utils/enums';

import { getId, isStandardService } from '../../slice.tsx';
import { getFirstCustomerSite } from '../../../manage/jobs/jobTypes/slice';


export const fields = {
  subject: {
    id: 'subject',
    label: 'Subject',
    placeholder: 'Enter subject',
  },
  fromName: {
    id: 'fromName',
    label: 'From',
    placeholder: 'Enter from name',
  },
  emailAddresses: {
    id: 'emailAddresses',
    label: 'To',
    placeholder: 'Multiple emails with commas',
    email: 'Must be a valid email',
  },
  message: {
    id: 'message',
    label: 'Body',
    placeholder: '',
  },

  
  proformaInvoiceTotal: {
    id: 'proformaInvoiceTotal',
    label: 'Amount to collect',
    placeholder: '',
  },
  proformaPaymentMethodMetaId: {
    id: 'proformaPaymentMethodMetaId',
    label: 'Payment method',
    placeholder: '',
  },
  proformaPaymentType: {
    id: 'proformaPaymentType',
    label: 'Collected by driver',
    placeholder: '',
  },
  proformaPaymentReceived: {
    id: 'proformaPaymentReceived',
    label: 'Payment received',
    placeholder: '',
  },
};

export const formSchema = (id: number|null= null) => {
  return Yup.object().shape({
    subject: Yup.string().nullable().required().label(fields.subject.label),
    emailAddresses: Yup.array().of(Yup.string().email(fields.emailAddresses.email)).min(1).label(fields.emailAddresses.label),
    fromName: Yup.string().nullable().required().label(fields.fromName.label),
    messagePlainText: Yup.string().nullable().required().label(fields.message.label),

    proformaInvoiceTotal: Yup.number().nullable().min(0).label(fields.proformaInvoiceTotal.label),
    proformaPaymentMethodMetaId: Yup.number().nullable().min(0).label(fields.proformaPaymentMethodMetaId.label),
    proformaPaymentType: Yup.number().nullable().min(0).label(fields.proformaPaymentType.label),
    proformaPaymentReceived: Yup.number().nullable().min(0).label(fields.proformaPaymentReceived.label),
  })
}


let formikContext: any = null;
export const FormikContext = createContext<any>(null);
export const useFormikContext = () => {
    formikContext = useContext(FormikContext);
    if (!formikContext) {
      throw new Error('useFormikContext must be used within a FormikProvider');
    }
    return formikContext;
};


export const prepareForm = (values: any = null, defValues: any = null, accountBillingProfile: any = null) => {
  let form = _.cloneDeep(values);
  let data = _.cloneDeep(defValues);
  
  if(data && form){
    let contactEmails = [];
    let customerSiteDetails = getFirstCustomerSite(values);
    if(customerSiteDetails && customerSiteDetails.site && customerSiteDetails.site.contactEmails && customerSiteDetails.site.contactEmails.length > 0){
      contactEmails = customerSiteDetails?.site?.contactEmails;
    }


    let subject = '';
    let emailAddresses = [];
    let fromName = '';
    let messagePlainText = h2p('');
    let messageHTML = '';
    let message = createEditorState('');


    if(accountBillingProfile && accountBillingProfile.accountEmailTemplates && accountBillingProfile.accountEmailTemplates.length > 0){
      let accountEmailTemplate = accountBillingProfile.accountEmailTemplates.find((x: any) => x.type === AccountEmailTemplateType.ProformaInvoiceSent);
      if(accountEmailTemplate){
        let toArr = [];

        if(accountEmailTemplate.recipientCc && accountEmailTemplate.recipientCc != ''){
          let tmplEmails = accountEmailTemplate.recipientCc.split(',');
          if(tmplEmails && tmplEmails.length > 0){
            tmplEmails.forEach((itm: any) => {
              toArr.push(itm);
            });
          }
        }

        if(contactEmails.length > 0){
          for(let i = 0; i < contactEmails.length; i++){
            if(contactEmails[i].customerContactPersonId){
              if(contactEmails[i].customerContactPerson.emailAddress){
                toArr.push(contactEmails[i].customerContactPerson.emailAddress);
              }
            } else {
              if(contactEmails[i].emailAddress){
                toArr.push(contactEmails[i].emailAddress);
              }
            }
          }
        }

        messagePlainText = h2p(accountEmailTemplate.message);
        messageHTML = accountEmailTemplate.message;
        message = createEditorState(messageHTML);

        emailAddresses = toArr;
        fromName = accountEmailTemplate.fromName;
        subject = accountEmailTemplate.subject;
      }
    }

    data['subject'] = subject;
    data['emailAddresses'] = emailAddresses;
    data['contactEmails'] = contactEmails;
    data['fromName'] = fromName;
    data['messagePlainText'] = messagePlainText;
    data['messageHTML'] = messageHTML;
    data['message'] = message;

    
    let amountToCollect = (isNumeric(form.amountToCollect)) ? form.amountToCollect : null;
    // let collectedAmount = (isNumeric(form.collectedAmount)) ? form.collectedAmount : null;
    let proformaInvoiceTotal = (isNumeric(form.proformaInvoiceTotal)) ? form.proformaInvoiceTotal : amountToCollect;
    let proformaPaymentMethodMetaId = (isNumeric(form.proformaPaymentMethodMetaId)) ? form.proformaPaymentMethodMetaId : null;
    let proformaPaymentMethodMetaName = (form.proformaPaymentMethodMetaName && form.proformaPaymentMethodMetaName != '') ? form.proformaPaymentMethodMetaName : '';
    let proformaPaymentType = (isNumeric(form.proformaPaymentType)) ? form.proformaPaymentType : null;
    let proformaPaymentReceived = (isNumeric(form.proformaPaymentReceived)) ? form.proformaPaymentReceived : null;
    let proformaInvoiceStatus = (isNumeric(form.proformaInvoiceStatus)) ? form.proformaInvoiceStatus : null;

    data['proformaInvoiceTotal'] = proformaInvoiceTotal;
    data['proformaPaymentMethodMetaId'] = proformaPaymentMethodMetaId;
    data['proformaPaymentMethodMetaName'] = proformaPaymentMethodMetaName;
    data['proformaPaymentType'] = proformaPaymentType;
    data['proformaPaymentReceived'] = proformaPaymentReceived;
    data['proformaInvoiceStatus'] = proformaInvoiceStatus;
  }
  
  return data;
};
export const prepareData = (values: any = null) => {
  let data: any = {};

  let form = _.cloneDeep(values);

  if(form){
    let emailAddresses = form.emailAddresses && form.emailAddresses.length > 0 ? form.emailAddresses.join(',') : '';

    data['jobId'] = getId();

    data['subject'] = form.subject;
    data['emailAddresses'] = emailAddresses;
    data['fromName'] = form.fromName;
    data['message'] = form.messageHTML;

    data['includeAttachment'] = true;

    
    data['proformaInvoiceTotal'] = form.proformaInvoiceTotal;
    data['proformaPaymentMethodMetaId'] = form.proformaPaymentMethodMetaId;
    data['proformaPaymentMethodMetaName'] = form.proformaPaymentMethodMetaName;
    data['proformaPaymentType'] = form.proformaPaymentType;
    data['proformaPaymentReceived'] = form.proformaPaymentReceived;
    data['proformaInvoiceStatus'] = form.proformaInvoiceStatus;
    data['proformaInvoiceDate'] = form.proformaInvoiceDate;
    data['proformaInvoiceNumebr'] = form.proformaInvoiceNumebr;
    data['proformaPricings'] = form.proformaPricings;
  }

  return data;
};


export const stringToHtmlTrim = (value: any) => {
  try {
    let result = value && value !== "" ? value.toString().replace(/[ \t]+/g, ' ').trim() : value;
    return parse(result)
  } catch(e){
    return value
  }
};
export const strToBool = (status: any = '') => {
  if (status == 'True') {
      return true;
  } else if (status == 'False') {
      return false;
  } else {
      return false;
  }
};
export const findSettings = (settings: any = [], text: any = '', param: any = 'variableName') => {
  let status = null;

  if (settings && settings.length > 0) {
    let statusItem = settings.filter((x: any) => x[param].toLowerCase().trim() === text.toLowerCase().trim());

    if (statusItem && statusItem.length > 0) {
      status = statusItem[0];
    }
  }

  return status;
};
export const findSettingsItem = (settings: any = null, type: any = AccountDocSettingVariables.String, param: any = 'variableValue') => {
  let status = (type === AccountDocSettingVariables.Show) ? false : '';

  if (settings) {
    status = settings[param];

    if (type === AccountDocSettingVariables.Show) {
      status = strToBool(status);
    }
  }

  return status;
};
export const getAccountDocSettingVariables = (accountBillingProfile: any = null) => {
  let detailsDeliveryOrder = null;
  if (accountBillingProfile && accountBillingProfile.accountDocSettings && accountBillingProfile.accountDocSettings.length > 0) {
    let items = accountBillingProfile.accountDocSettings.filter((x: any) => x.type === AccountDocSettingType.DeliveryOrder);
    if (items && items.length > 0) {
      detailsDeliveryOrder = items[0];
    }
  }

  return detailsDeliveryOrder &&
    detailsDeliveryOrder.accountDocSettingVariables &&
    detailsDeliveryOrder.accountDocSettingVariables.length > 0
    ? detailsDeliveryOrder.accountDocSettingVariables
    : [];
};
export const getAccountDocSettingItem = (accountBillingProfile: any = null, variableName: any = "", type: any = AccountDocSettingVariables.String, defaultValue: any = "") => {
  let accountDocSettingVariables = getAccountDocSettingVariables(accountBillingProfile);
  let accountDocSettingItem = findSettings(accountDocSettingVariables, variableName);

  if (type === AccountDocSettingVariables.Show) {
    let defValue = strToBool(defaultValue);
    let value = findSettingsItem(accountDocSettingItem, type);
    return value === false || value === true ? value : defValue;
  } else {
    let value = findSettingsItem(accountDocSettingItem, type);
    return value && value !== "" ? value : defaultValue;
  }
};
export const getAccountDocSettingVariablesProformaInvoice = (accountBillingProfile: any = null) => {
  let detailsProformaInvoice = null;
  if (accountBillingProfile && accountBillingProfile.accountDocSettings && accountBillingProfile.accountDocSettings.length > 0) {
    let items = accountBillingProfile.accountDocSettings.filter((x: any) => x.type === AccountDocSettingType.ProformaInvoice);
    if (items && items.length > 0) {
      detailsProformaInvoice = items[0];
    }
  }

  return detailsProformaInvoice &&
    detailsProformaInvoice.accountDocSettingVariables &&
    detailsProformaInvoice.accountDocSettingVariables.length > 0
    ? detailsProformaInvoice.accountDocSettingVariables
    : [];
};
export const getAccountDocSettingItemProformaInvoice = (accountBillingProfile: any = null, variableName: any = "", type: any = AccountDocSettingVariables.String, defaultValue: any = "") => {
  let accountDocSettingVariables = getAccountDocSettingVariablesProformaInvoice(accountBillingProfile);
  let accountDocSettingItem = findSettings(accountDocSettingVariables, variableName);

  if (type === AccountDocSettingVariables.Show) {
    let defValue = strToBool(defaultValue);
    let value = findSettingsItem(accountDocSettingItem, type);
    return value === false || value === true ? value : defValue;
  } else {
    let value = findSettingsItem(accountDocSettingItem, type);
    return value && value !== "" ? value : defaultValue;
  }
};

export const prepareDateTime = (form: any) => {
  let jobDate = (form && form.jobDate && form.jobDate != '') ? moment(form.jobDate, dateFormat()).format(dateFormat()) : null;
  let jobTimeSpecific = (form && form.jobTimeSpecific && form.jobTimeSpecific != '') ? moment(form.jobTimeSpecific, timeMeridianFormat()).format(timeMeridianFormat()) : null;

  let jobDateTime = '';
  if(jobDate && jobTimeSpecific){
    jobDateTime = moment(concatDateTimeNoConvrsion(jobDate, jobTimeSpecific)).format(dateTimeMeridianFormat());
  } else if(jobDate){
    jobDateTime = moment(jobDate, dateFormat()).format(dateFormat());
  }

  return jobDateTime;
}

export const getTotal = (values: any, newPricings: any = [], field: string = 'pricings') => {
  let subtotal = 0;
  let invoiceTaxRate = 0;

  let newPricingsArr = (newPricings && newPricings.length > 0) ? newPricings : [];
  let pricings = (values && values[field] && values[field].length > 0) ? values[field] : newPricingsArr;

  let standardItems = pricings && (pricings.filter((x: any) => isStandardService(x)).length > 0) ? pricings.filter((x: any) => isStandardService(x)) : [];
  let additionalItems = pricings && (pricings.filter((x: any) => x.serviceType === ServiceType.AdditionalService).length > 0) ? pricings.filter((x: any) => x.serviceType === ServiceType.AdditionalService) : [];
  
  standardItems.forEach((item: any, i: any) => {
      if(invoiceTaxRate == 0 && isNumeric(item?.invoiceTaxRate)){
          invoiceTaxRate = item?.invoiceTaxRate || 0;
      }

      let quantity = isNumeric(item.quantity) ? item.quantity : 0;
      let price = isNumeric(item.price) ? item.price : 0;
      subtotal = subtotal + (quantity * price)
  }, 0);
  additionalItems.forEach((item: any, i: any) => {
      if(invoiceTaxRate == 0 && isNumeric(item?.invoiceTaxRate)){
          invoiceTaxRate = item?.invoiceTaxRate || 0;
      }

      let quantity = isNumeric(item.quantity) ? item.quantity : 0;
      let price = isNumeric(item.price) ? item.price : 0;
      subtotal = subtotal + (quantity * price)
  }, 0);

  let totalGST = subtotal * (invoiceTaxRate / 100);
  let total = subtotal + totalGST;

  let paymentReceived = (values && isNumeric(values.proformaPaymentReceived)) ? values.proformaPaymentReceived : 0;
  let balance = total - paymentReceived;
  

  return {
    subtotal: subtotal,
    totalGST: totalGST,
    total: total,
    paymentReceived: paymentReceived,
    balance: balance,
  };
}
export const proformaInvoiceStatusText = (proformaInvoiceStatus: any, total: any, price: any, justPaid: boolean = false) => {
  if(proformaInvoiceStatus === ProformaInvoiceStatus.Sent){
    return 'SENT';
  } else if(proformaInvoiceStatus === ProformaInvoiceStatus.Accepted){
    return 'ACCEPTED';
  } else if(proformaInvoiceStatus === ProformaInvoiceStatus.Declined){
    return 'DECLINED';
  } else if(proformaInvoiceStatus === ProformaInvoiceStatus.Paid){
    if(justPaid){
      return 'PAID';
    } else {
      if(parseFloat(price || 0) < parseFloat(total || 0)){
        return 'PARTIAL (' + getCurrency() + formatNumber(price || 0) + ')';
      } else {
        return 'FULLY PAID';
      }
    }
  } else {
    return 'DRAFT';
  }
}
export const proformaInvoiceHeaderStatusText = (values: any, justPaid: boolean = false) => {
  let total: any = (values && isNumeric(values.proformaInvoiceTotal)) ? values?.proformaInvoiceTotal : 0;
  let price: any = (values && isNumeric(values.proformaPaymentReceived)) ? values?.proformaPaymentReceived : 0;

  if(values?.proformaInvoiceStatus === ProformaInvoiceStatus.Sent){
    return 'Profroma Sent';
  } else if(values?.proformaInvoiceStatus === ProformaInvoiceStatus.Accepted){
    return 'Profroma Accepted';
  } else if(values?.proformaInvoiceStatus === ProformaInvoiceStatus.Declined){
    return 'Profroma Declined';
  } else if(values?.proformaInvoiceStatus === ProformaInvoiceStatus.Paid){
    if(justPaid){
      return 'Profroma Paid';
    } else {
      if(parseFloat(price) < parseFloat(total)){
        return 'Profroma Partial (' + getCurrency() + formatNumber(price) + ')';
      } else {
        return 'Profroma Fully Paid';
      }
    }
  } else {
    if(values?.proformaInvoice != ''){
      return 'Profroma Created';
    } else {
      return '';
    }
  }
}


export interface initialValuesStruct {
  subject: string,
  emailAddresses: Array<any>,
  contactEmails: Array<any>,
  fromName: string,
  messagePlainText: string,
  messageHTML: string,
  message: any,

  proformaInvoiceTotal: number|null,
  proformaPaymentMethodMetaId: number|null,
  proformaPaymentMethodMetaName: string|null,
  proformaPaymentType: number|null,
  proformaPaymentReceived: number|null,
  proformaInvoiceStatus: number|null,
};
export const initialValues: initialValuesStruct = {
  subject: '',
  emailAddresses: [],
  contactEmails: [],
  fromName: '',
  messagePlainText: '',
  messageHTML: '',
  message: '',

  proformaInvoiceTotal: null,
  proformaPaymentMethodMetaId: null,
  proformaPaymentMethodMetaName: null,
  proformaPaymentType: ProformaPaymentType.NotCollectedByDriver,
  proformaPaymentReceived: null,
  proformaInvoiceStatus: null,
};


interface InitState {
  isLoading: boolean,
  show: boolean,
  form: any,
  tab: string,
  
  isLoadingAccountBillingProfile: boolean,
  accountBillingProfile: any,
}

function NewReducer() {
  const name = 'jobFormProformaInvoiceSlice';


  const initialState: InitState = {
    isLoading: false,
    show: false,
    form: null,
    tab: 'tab1',

    isLoadingAccountBillingProfile: false,
    accountBillingProfile: null,
  };


  const reducers = {
    resetSlice: () => {
      return initialState;
    },
    setLoading: (state: InitState, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setShow: (state: InitState, action: PayloadAction<{ show: boolean, form: any }>) => {
      state.show = action.payload.show;
      state.form = action.payload.form;
    },
    setTab: (state: InitState, action: PayloadAction<string>) => {
      state.tab = action.payload;
    },
    setForm: (state: InitState, action: PayloadAction<any>) => {
      state.form = action.payload;
    },
    
    startDetailsAccountBillingProfile: (state: InitState) => {
      state.isLoadingAccountBillingProfile = true;
      state.accountBillingProfile = null;
    },
    finishDetailsAccountBillingProfile: (state: InitState, action: PayloadAction<any>) => {
      let data = (action.payload) ? action.payload : null;
      state.accountBillingProfile = data;
      state.isLoadingAccountBillingProfile = false;
    },

    startSendCompleteJobEmail: (state: InitState) => {
      state.isLoading = true;
    },
    finishSendCompleteJobEmail: (state: InitState, action: PayloadAction<any>) => {
      state.isLoading = false;
    },

    startGetJobDoc: (state: InitState) => {
      state.isLoading = true;
    },
    finishGetJobDoc: (state: InitState, action: PayloadAction<any>) => {
      state.isLoading = false;
    },
  };


  const apis = {
    callDetailsAccountBillingProfileApi: (id: any, callback: (state: boolean, data: any) => void) => async (dispatch: any) => {
      dispatch(actions.startDetailsAccountBillingProfile());

      await axios.get('AccountBillingProfile/' + id).then((result: any) => {
        let data = result.data;
        
        successAPI(data);

        callback(true, data);
        dispatch(actions.finishDetailsAccountBillingProfile(data));
      }).catch((error: any) => {
        errorAPI(error);
        
        callback(false, null);
        dispatch(actions.finishDetailsAccountBillingProfile(null));
      });
    },

    callSendCompleteJobEmailApi: (params: any, callback: (state: boolean, data: any) => void) => async (dispatch: any) => {
      dispatch(actions.startSendCompleteJobEmail());

      await axios.post('job/send-proforma-invoice-email', params).then((result: any) => {
        let data = result.data;
        
        callback(true, data);
        dispatch(actions.finishSendCompleteJobEmail(data));
      }).catch((error: any) => {
        errorAPI(error);
        
        callback(false, null);
        dispatch(actions.finishSendCompleteJobEmail(null));
      });
    },

    callGetJobDocApi: (params: any, callback: (state: boolean, data: any) => void) => async (dispatch: any) => {
      dispatch(actions.startGetJobDoc());

      await axios.get('job/get-job-proforma-invoice/' + params?.jobId, params).then((result: any) => {
        let data = result.data;
        
        callback(true, data);
        dispatch(actions.finishGetJobDoc(data));
      }).catch((error: any) => {
        errorAPI(error);
        
        callback(false, null);
        dispatch(actions.finishGetJobDoc(null));
      });
    },
  };


  const { reducer, actions } = createSlice({
    name,
    initialState,
    reducers,
  });


  return {
    reducer,
    ...actions,
    ...apis,
  };
}


export default NewReducer();